import axios from "../../axios";

export default {
  registerMerchant({ commit }, payload) {
    const headers = {
      headers: {
        "Content-Type": "application/json",
        ApiKey: "1qazXSW@"
      }
    };
    return new Promise((resolve, reject) => {
      axios
        .post("api/whiteknight/merchantregistration", payload, headers)
        .then(response => {
          console.log(response);
          resolve(response);
        })
        .catch(error => {
          console.log(error);
          reject(error);
        });
    });
  },
  getGiftcardImgUrl({ commit }, payload) {
    const headers = {
      headers: {
        "Content-Type": "application/json",
        ApiKey: "1qazXSW@"
      }
    };
    axios
      .post("api/imageupload", payload, headers)
      .then(response => {
        console.log(response);
      })
      .catch(error => {
        console.log(error);
      });
  }
};
